export default __webpack_public_path__ + "static/media/available-training-courses.f0a17824.svg";